module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"retry":"Retry","upload_failed":"Upload Failed","ai_clothing_detected":"AI Try-on Photo","ai_analyzing":"AI Analyzing..."}}')
  delete Component.options._Ctor
}
